import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'WifiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wifi",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 18l.01 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.343 12.343a8 8 0 0 1 11.314 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
    }, null), _createTextVNode(" ")]);
  }
};